import React, { FC, ReactNode } from 'react'
import styles from 'styles/components/modal.module.scss'
import { Card, CardInner } from 'components/Card'
import { use100vh } from 'react-div-100vh'

type Props = {
  open: boolean
  closeModal: () => void
  children: ReactNode
}

const ImageModal: FC<Props> = (props) => {
  const { open, closeModal, children } = props
  const maxHeight = use100vh()

  return (
    // styles.openクラスを適用するとopacityのアニメーションでフェードイン
    <div className={open ? styles.open : ''}>
      <div className={styles.overlay}>
        <div className={styles.overlay__background} onClick={closeModal} />
        {open && (
          <div className={styles.overlay__container} style={{ maxHeight: maxHeight ?? '100vh' }}>
            <Card>
              <CardInner align={'center'}>{children}</CardInner>
            </Card>
          </div>
        )}
      </div>
    </div>
  )
}

export default ImageModal
